import React, { useContext } from "react";
import { AppContext } from "../../components/States/AppContext";

//styles
import { LockBoxOverlay } from "./LockBox.elements";

const LockBox = () => {
  const { state, setState } = useContext(AppContext);

  return (
    <>
      <LockBoxOverlay lock={state.isLocked} />
    </>
  );
};

export default LockBox;
